<template>
  <v-expansion-panel :class="headerClass">
    <v-expansion-panel-header
      :class="headerClass"
      expand-icon="mdi-menu-down"
      style="min-height: 40px !important"
    >
      <v-row class="ma-0">
        <v-col cols="6" class="pa-0 d-flex align-center">
          <span :class="headerClass"> # {{ tripIndex + 1 }} </span>
          <span>&nbsp; | &nbsp;</span>
          <v-tooltip
            content-class="no-opacity"
            color="white"
            max-width="300"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-icon :class="headerClass" class="mr-2"
                  >mdi-account-tie-hat</v-icon
                >
                <span :class="headerClass">
                  {{ tripObject.driver }}
                </span>
              </div>
            </template>
            <div class="white text_color--text border-light pa-3 rounded-lg">
              <v-row no-gutters>
                <v-col
                  cols="12"
                  class="py-1 d-flex justify-space-between"
                  v-if="
                    tripObject &&
                    tripObject.asset_details &&
                    tripObject.asset_details.driver &&
                    tripObject.asset_details.driver.name
                  "
                >
                  <span class="pr-2"> {{ fleetModule.driver }} </span>
                  <span class="font-weight-bold">{{
                    tripObject.asset_details.driver.name
                  }}</span>
                </v-col>
                <v-col
                  cols="12"
                  class="py-1 d-flex justify-space-between"
                  v-if="
                    tripObject &&
                    tripObject.asset_details &&
                    tripObject.asset_details.driver &&
                    tripObject.asset_details.driver.shift
                  "
                >
                  <span class="pr-2"> {{ fleetModule.driver }}'s Shift </span>
                  <span class="font-weight-bold">{{
                    tripObject.asset_details.driver.shift
                  }}</span>
                </v-col>
              </v-row>
            </div>
          </v-tooltip>
          <span>&nbsp; | &nbsp;</span>
          <v-tooltip
            content-class="no-opacity"
            color="white"
            max-width="300"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-icon :class="headerClass" class="mr-2">mdi-truck</v-icon>
                <span :class="headerClass">
                  {{ tripObject.vehicle }}
                </span>
              </div>
            </template>
            <div class="white text_color--text border-light pa-3 rounded-lg">
              <v-row no-gutters>
                <v-col cols="12" class="py-1 d-flex justify-space-between">
                  <span class="pr-2"> CBM Capacity </span>
                  <span
                    class="font-weight-bold"
                    v-if="
                      tripObject &&
                      tripObject.asset_details &&
                      tripObject.asset_details.vehicle &&
                      tripObject.asset_details.vehicle.cbm_capacity
                    "
                    >{{ tripObject.asset_details.vehicle.cbm_capacity }}</span
                  >
                  <span v-else> - </span>
                </v-col>
                <v-col cols="12" class="py-1 d-flex justify-space-between">
                  <span
                    v-if="
                      tripObject &&
                      tripObject.asset_details &&
                      tripObject.asset_details.vehicle &&
                      tripObject.asset_details.vehicle.tonnage_capacity
                    "
                  >
                    Tonnage Capacity
                  </span>
                  <span class="font-weight-bold">
                    {{ tripObject.asset_details.vehicle.tonnage_capacity }}
                  </span>
                </v-col>
                <v-col
                  cols="6"
                  class="d-flex align-center py-1 justify-space-between"
                  v-if="
                    tripObject.asset_details &&
                    tripObject.asset_details.vehicle &&
                    tripObject.asset_details.vehicle.storage_type
                  "
                >
                  <span> Storage Type(s) </span>
                </v-col>
                <v-col
                  cols="6"
                  class="py-1 d-flex justify-end"
                  v-if="
                    tripObject.asset_details &&
                    tripObject.asset_details.vehicle &&
                    tripObject.asset_details.vehicle.storage_type
                  "
                >
                  <v-row no-gutters>
                    <v-col
                      cols="12"
                      v-for="(type, type_index) in tripObject.asset_details
                        .vehicle.storage_type"
                      :key="type_index"
                      class="d-flex justify-end"
                    >
                      <v-icon :style="{ color: type.color }" class="mr-1">
                        mdi-checkbox-blank
                      </v-icon>
                      <span class="font-weight-bold text-capitalize">
                        {{ type.name }}
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </v-tooltip>
        </v-col>
        <v-col cols="1" class="d-flex align-center">
          <v-tooltip
            v-if="
              tripObject &&
              tripObject.transport_detail &&
              tripObject.transport_detail.tags.length > 0
            "
            top
            content-class="no-opacity"
            :close-delay="0"
            :open-delay="200"
            color="transparent"
            max-width="300"
          >
            <template v-slot:activator="{ on, attrs }">
              <span
                class="trip-expansion-title mr-1 pa-1"
                v-bind="attrs"
                v-on="on"
              >
                <span>
                  <v-icon color="white">mdi-alpha-t-box </v-icon>
                </span>
              </span>
            </template>
            <div
              class="background-white border-y-grey border-x-grey pa-3 rounded-lg"
            >
              <v-row no-gutters>
                <v-col cols="12" :class="headerClass">
                  <span> <b>Assigned Tag</b> </span>
                  <hr style="opacity: 0.3" class="mt-1 mb-1" />
                </v-col>
                <v-col cols="12" class="text-grey py-1">
                  <p
                    class="pa-0 ma-0"
                    v-for="(tag, tagIndex) in tripObject.transport_detail.tags"
                    :key="tagIndex"
                  >
                    <span> {{ tag }} </span>
                  </p>
                </v-col>
              </v-row>
            </div>
          </v-tooltip>

          <v-tooltip
            v-if="
              tripObject &&
              tripObject.transport_detail &&
              tripObject.transport_detail.zones.length > 0
            "
            top
            content-class="no-opacity"
            :close-delay="0"
            :open-delay="200"
            color="transparent"
            max-width="300"
          >
            <template v-slot:activator="{ on, attrs }">
              <span
                class="trip-expansion-title mr-1 pa-1"
                v-bind="attrs"
                v-on="on"
              >
                <span>
                  <v-icon color="white">mdi-alpha-z-box </v-icon>
                </span>
              </span>
            </template>
            <div
              class="background-white border-y-grey border-x-grey pa-3 rounded-lg"
            >
              <v-row no-gutters>
                <v-col cols="12" :class="headerClass">
                  <span> <b>Assigned Zones </b></span>
                  <hr style="opacity: 0.3" class="mt-1 mb-1" />
                </v-col>
                <v-col cols="12" class="text-grey py-1">
                  <p
                    class="pa-0 ma-0"
                    v-for="(zone, zoneIndex) in tripObject.transport_detail
                      .zones"
                    :key="zoneIndex"
                  >
                    {{ zone }}
                  </p>
                </v-col>
              </v-row>
            </div>
          </v-tooltip>
        </v-col>
        <v-col cols="5" class="pa-0 d-flex justify-end align-center">
          <span
            class="trip-expansion-title mr-1 pa-1"
            v-if="tripObject.customer_address_count"
          >
            <span>Customers:</span>
            {{ tripObject.customer_address_count }}
          </span>
          <span
            class="tripObject-expansion-title mr-1 pa-1"
            v-if="tripObject.planned_locations_count"
          >
            <span>Drop Points:</span>
            {{ tripObject.planned_locations_count }}
          </span>

          <v-btn text small readonly>
            <span class="trip-expansion-title">
              <v-icon class="mr-2" :class="headerClass">
                mdi-archive-outline
              </v-icon>
              <span :class="headerClass"
                >Orders {{ tripObject.planned_orders.length }}</span
              >
            </span>
          </v-btn>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="mr-2"
                :class="headerClass"
                v-bind="attrs"
                v-on="on"
                @click.stop="$emit('viewTripOnMap', tripObject)"
              >
                mdi-map
              </v-icon>
            </template>
            <span>View On Map</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-if="!tripObject.action_taken"
                v-bind="attrs"
                v-on="on"
                :class="headerClass"
                @click.stop="$emit('removeTrip')"
              >
                mdi-close
              </v-icon>
            </template>
            <span>Delete {{ tripModule.trip }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <template v-slot:actions>
        <v-icon :class="headerClass"> mdi-chevron-down </v-icon>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content
      class="expansion-container-margin rounded rounded-t-0 pa-0"
      color="white"
    >
      <v-row no-gutters>
        <v-col
          cols="12"
          class="pa-2"
          v-if="tripErrors && tripErrors.non_field_errors"
        >
          <v-alert dense type="error" class="ma-0">
            <v-list
              class="pa-0"
              dense
              style="background: inherit !important"
              v-for="(error, i) in tripErrors.non_field_errors"
              :key="i"
            >
              <v-list-item dense style="min-height: 20px !important">
                <span>{{ i }} .</span><span>{{ error }}</span>
                <v-spacer></v-spacer>
                <v-btn
                  color="white"
                  icon
                  @click="$emit('removeError', tripIndex, 'non_field_errors')"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-list-item>
            </v-list>
          </v-alert>
        </v-col>
        <v-col cols="12">
          <v-row class="ma-0">
            <v-col cols="4">
              <PieChart
                v-if="isChartEnable"
                :height="150"
                class="small1 px-sm-0 mt-3"
                :data="{
                  labels: Object.keys(tripObject.storage_type_count).map(
                    (item) =>
                      item
                        ? `${item
                            .replaceAll('_', ' ')
                            .charAt(0)
                            .toUpperCase()}${item.substr(1, item.length)}`
                        : ''
                  ),
                  datasets: generateChartObject(tripObject.storage_type_count),
                }"
              />
            </v-col>
            <v-col cols="8">
              <v-row no-gutters class="tripObject-expansion-body pt-2">
                <v-col cols="3">
                  <div v-if="tripObject && tripObject.utilize_percentage">
                    <VehicleUtilization
                      :data="tripObject.volume?.utilization_percentage"
                    />
                  </div>
                </v-col>

                <v-col cols="1"></v-col>

                <v-col cols="4" class="border-right-grey pt-2">
                  <v-card elevation="0">
                    <v-card-title class="pa-0">
                      <h6>Volume(CBM) Utilization</h6>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <span>
                        {{ tripObject.volume?.usage }}
                      </span>
                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col cols="4" class="border-right-grey pt-2">
                  <v-card elevation="0">
                    <v-card-title class="pa-0">
                      <h6>Weight(Ton) Utilization</h6>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <span>
                        {{ tripObject.mass?.usage }}
                      </span>
                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col cols="4" class="border-right-grey">
                  <v-card elevation="0">
                    <v-card-title class="pa-0">
                      <h6>Distance</h6>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <span>
                        {{ tripObject.distance }}
                      </span>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="4" class="border-right-grey pt-2">
                  <v-card elevation="0">
                    <v-card-title class="pa-0">
                      <h6>Total Time</h6>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <span>
                        {{ tripObject.total_time }}
                      </span>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="4" class="border-right-grey pt-2">
                  <v-card elevation="0">
                    <v-card-title class="pa-0">
                      <h6>Travelling Time</h6>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <span>
                        {{ tripObject.travelling_time }}
                      </span>
                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col
                  cols="4"
                  class="border-right-grey pt-2"
                  v-if="$helper.isCompanyHasItems()"
                >
                  <v-card elevation="0">
                    <v-card-title class="pa-0">
                      <h6>Total quantity</h6>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <span>
                        {{ tripObject.total_item_quantity }}
                      </span>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col
                  cols="4"
                  class="border-right-grey pt-2"
                  v-if="tripObject.transport_detail"
                >
                  <v-card elevation="0">
                    <v-card-title class="pa-0">
                      <h6>Shift Timings</h6>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <span v-if="tripObject.transport_detail.shift_start">
                        {{ tripObject.transport_detail.shift_start }}
                      </span>
                      <span v-else>-</span>
                      <span>To</span>
                      <span v-if="tripObject.transport_detail.shift_end">
                        {{ tripObject.transport_detail.shift_end }}
                      </span>
                      <span v-else>-</span>
                    </v-card-text>
                  </v-card>
                </v-col>
                <!-- <v-col
                  cols="4"
                  class="border-right-grey pt-2"
                  v-if="tripObject && tripObject.utilize_percentage"
                >
                  <v-card elevation="0">
                    <v-card-title class="pa-0 ">
                      <h6>Total Utilized %</h6>
                    </v-card-title>
                    <v-card-text class="pa-0 ">
                      <span>
                        {{ tripObject.utilize_percentage.used }}
                      </span>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col
                  cols="4"
                  class="border-right-grey pt-2"
                  v-if="tripObject && tripObject.utilize_percentage"
                >
                  <v-card elevation="0">
                    <v-card-title class="pa-0 ">
                      <h6>Total Unutilized %</h6>
                    </v-card-title>
                    <v-card-text class="pa-0 ">
                      <span>
                        {{ tripObject.utilize_percentage.unused }}
                      </span>
                    </v-card-text>
                  </v-card>
                </v-col> -->
                <!-- <v-col
                  cols="3"
                  class="border-right-grey pt-2"
                  v-if="tripObject && tripObject.packaging_info"
                >
                  <v-card elevation="0">
                    <v-card-title class="pa-0 ">
                      <h6>Packaging Type</h6>
                    </v-card-title>
                    <v-card-text class="pa-0 ">
                      <span>
                        {{ tripObject.packaging_info.packaging_type }}
                      </span>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col
                  cols="3"
                  class="border-right-grey pt-2"
                  v-if="tripObject && tripObject.packaging_info"
                >
                  <v-card elevation="0">
                    <v-card-title class="pa-0 ">
                      <h6>Packaging Fill ratio</h6>
                    </v-card-title>
                    <v-card-text class="pa-0 ">
                      <span>
                        {{ tripObject.packaging_info.packaging_ratio }} %
                      </span>
                    </v-card-text>
                  </v-card>
                </v-col> -->
                <v-col
                  cols="4"
                  class="border-right-grey pt-2"
                  v-if="tripObject && tripObject.packaging_info"
                >
                  <v-card elevation="0">
                    <v-card-title class="pa-0">
                      <h6>Packaging Information</h6>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <span>
                        {{ tripObject.packaging_info.package_required }} /
                        {{ tripObject.packaging_info.total_package }}
                      </span>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="3" class="app-search-input mt-4">
              <InputField
                label="Search"
                outlined
                dense
                v-model="mainSearch"
                clearable
                hide-details="auto"
              ></InputField>
            </v-col>
            <!-- v-if="
              userPermissions &&
              userPermissions.tripObject &&
              userPermissions.tripObject.add
            " -->
            <v-col cols="9" class="d-flex justify-end align-center pr-5">
              <PrimaryButton
                v-if="permissions.add"
                :disabled="
                  tripObject.action_taken ||
                  !tripObject.planned_orders ||
                  !tripObject.planned_orders.length > 0
                "
                @click.once="$emit('createSingleTrip', tripObject, tripIndex)"
                :name="`Create ${tripModule.trip}`"
              >
              </PrimaryButton>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          @dragenter.stop.prevent
          @dragover.stop.prevent
          @drop.stop.prevent="$emit('dropOrder', tripIndex)"
          class="pa-2 drop-container-expansion"
        >
          <div
            v-if="
              tripObject.planned_orders && !tripObject.planned_orders.length
            "
            class="d-flex align-center justify-center grey lighten-4 fill-height"
          >
            <span class="grey--text">Drop {{ orderModule.order }}'s here</span>
          </div>
          <v-data-table
            v-else
            :headers="tableHeaders"
            :items="tripObject.planned_orders"
            :items-per-page="-1"
            disable-pagination
            dense
            hide-default-footer
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr
                  v-for="(tripOrder, tripOrderIndex) in items"
                  :key="tripOrderIndex"
                  draggable
                  @dragenter.stop.prevent
                  @dragover.stop.prevent
                  @drag="$emit('orderDragStart', tripOrder.id, tripIndex)"
                  @drop.stop.prevent="
                    $emit('dropOrder', tripIndex, tripOrderIndex)
                  "
                  v-show="searchOrder(mainSearch, tripOrder)"
                >
                  <td v-if="hasError()">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="red"
                          v-if="hasOrderError(tripOrderIndex)"
                          v-bind="attrs"
                          v-on="on"
                          >mdi-alert</v-icon
                        >
                      </template>
                      <span>{{ getError(tripOrderIndex) }}</span>
                    </v-tooltip>
                  </td>
                  <td>{{ tripOrder.reference_number }}</td>
                  <td v-if="tripType == 'sales'">
                    {{ tripOrder.customer_code }}
                  </td>
                  <td v-if="tripType == 'sales'">
                    {{ tripOrder.location_id }}
                  </td>
                  <td class="text-truncate" style="max-width: 7vw">
                    <Tooltip
                      :top="true"
                      :right="true"
                      maxWidth="300px"
                      :tooltipText="tripOrder.customer_name"
                      :tooltipTitle="tripOrder.customer_name"
                      tooltipActivatorClass="text-truncate"
                      tooltipBackground="primary"
                      tooltipClass="white--text"
                    />
                  </td>
                  <td>{{ tripOrder.order_type }}</td>

                  <td class="text-truncate" style="max-width: 7vw">
                    <Tooltip
                      :top="true"
                      :right="true"
                      maxWidth="300px"
                      :tooltipText="tripOrder.address"
                      :tooltipTitle="tripOrder.address"
                      tooltipActivatorClass="text-truncate"
                      tooltipBackground="primary"
                      tooltipClass="white--text"
                    />
                  </td>

                  <td style="min-width: 8vw">{{ tripOrder.volume }}</td>
                  <td style="min-width: 7vw">{{ tripOrder.weight }}</td>
                  <td
                    v-if="
                      $helper.isCompanyHasItems() &&
                      !headers.includes('original_quantity')
                    "
                  >
                    {{ tripOrder.total_quantity }}
                  </td>
                  <td style="min-width: 10vw">
                    {{ tripOrder.location_window }}
                  </td>
                  <td>{{ tripOrder.processing_time }}</td>
                  <td>
                    <span
                      v-if="tripOrder.timings && tripOrder.timings.pickup_time"
                    >
                      {{ tripOrder.timings.pickup_time }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-if="tripOrder.timings && tripOrder.timings.drop_time"
                    >
                      {{ tripOrder.timings.drop_time }}
                    </span>
                  </td>
                  <td v-if="!tripObject.action_taken && permissions.delete">
                    <v-btn
                      depressed
                      x-small
                      class="error"
                      @click="
                        $emit('removeOrderFromTrip', tripOrder.id, tripIndex)
                      "
                    >
                      <v-icon color="white" x-small> mdi-close </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { fleetModule, orderModule, tripModule } from "@/utils/moduleMapping";
import Tooltip from "@/components/BaseComponents/Tooltip.vue";
import VehicleUtilization from "@/components/BaseComponents/VehicleUtilization.vue";

export default {
  components: {
    Tooltip,
    VehicleUtilization,
  },
  props: {
    value: {
      required: true,
    },
    tripType: {
      default: "sales",
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
    tripIndex: {
      required: true,
    },
    tripErrors: {
      required: true,
    },
    driverList: {
      type: Array,
      default: () => [],
    },
    vehicleList: {
      type: Array,
      default: () => [],
    },
    headerClass: { type: String },
  },
  data() {
    return {
      fleetModule,
      tripModule,
      orderModule,
      orderHeaders: [
        {
          text: "Order Reference Number",
          value: "reference_number",
          sortable: false,
        },

        { text: "Customer Name", value: "customer_name", sortable: false },
        { text: "Order Type", value: "order_type", sortable: false },

        { text: "Address", value: "address", sortable: false },

        {
          text: "Volume (CBM)",
          value: "volume",
          sortable: false,
        },
        {
          text: "Weight (Kg)",
          value: "weight",
          sortable: false,
        },
        { text: "Time Window", value: "location_window", sortable: false },
        { text: "Processing time", value: "processing_time", sortable: false },
        {
          text: "Arrival Time",
          value: "timings",
          sortable: false,
        },
        {
          text: "Departure Time",
          value: "timings",
          sortable: false,
        },
      ],
      isChartEnable: true,
      mainSearch: null,
      userPermissions: {
        add: true,
        change: true,
        delete: true,
      },
      permissions: this.$permissions.getPermission("trip_planning"),
    };
  },
  watch: {},
  computed: {
    tripObject: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    headers() {
      return this.orderHeaders.map((v) => v.value);
    },
    tableHeaders() {
      if (
        this.tripType == "sales" &&
        !this.headers.includes("customer_code") &&
        !this.headers.includes("location_id")
      ) {
        this.orderHeaders.splice(
          1,
          0,
          ...[
            { text: "Customer Code", value: "customer_code", sortable: false },
            { text: "Location ID", value: "location_id", sortable: false },
          ]
        );
      }

      if (
        this.$helper.isCompanyHasItems() &&
        !this.headers.includes("total_quantity")
      ) {
        this.orderHeaders.splice(this.tripType == "sales" ? 8 : 6, 0, {
          text: "Original Quantity",
          value: "total_quantity",
          sortable: false,
          hide: this.$helper.isCompanyHasItems(),
        });
      }

      return [
        ...(this.hasError()
          ? [
              {
                text: "#",
                value: "id",
                sortable: false,
              },
            ]
          : []),
        ...this.orderHeaders,

        ...(!this.tripObject.action_taken
          ? [{ text: "Actions", value: "id", sortable: false }]
          : []),
      ];
    },
  },
  methods: {
    searchOrder(search, order = null) {
      if (search && search.length > 3) {
        if (
          order &&
          order.reference_number.toLowerCase().indexOf(search.toLowerCase()) !=
            -1
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    generateChartObject(tripValue) {
      return [
        {
          label: "Payment Type",
          data: Object.values(tripValue),
          backgroundColor: ["#e6e7e8", "#D7CCC8", "#FFCDD2", "#607D8B"],
        },
      ];
    },
    hasError() {
      return (
        this.tripErrors &&
        this.tripErrors.planned_orders &&
        this.tripErrors.planned_orders.some(
          (error) => error && Object.keys(error).length
        )
      );
    },
    hasOrderError(orderIndex) {
      return (
        this.hasError() &&
        this.tripErrors.planned_orders[orderIndex] &&
        this.tripErrors.planned_orders[orderIndex].non_field_errors
      );
    },
    getError(orderIndex) {
      let error = null;
      if (this.hasOrderError(orderIndex)) {
        error =
          this.tripErrors.planned_orders[orderIndex].non_field_errors.join();
      }
      return error;
    },
  },
};
</script>

<style>
.v-expansion-panel-content__wrap {
  padding: 0px;
}
.expansion-container-margin {
  margin: 2px;
}

.drop-container-expansion {
  min-height: 150px;
}
</style>
